import React from "react";
import { Box } from '@mui/material';
import SubscriptionForm from './SubscriptionForm';
import FooterMain from './FooterMain';
import FooterBottom from './FooterBottom';

const Footer = () => {
  return (
    <Box component="footer" sx={{ mt: 5, pt:3, bgcolor: 'black'}}>
      <SubscriptionForm />
      <FooterMain />
      <FooterBottom />
    </Box>
  );
};

export default Footer;
